import { render, staticRenderFns } from "./right4.vue?vue&type=template&id=3b74a4e5&scoped=true&"
import script from "./right4.vue?vue&type=script&lang=js&"
export * from "./right4.vue?vue&type=script&lang=js&"
import style0 from "./right4.vue?vue&type=style&index=0&id=3b74a4e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74a4e5",
  null
  
)

export default component.exports